export default "__VITE_ASSET__DjptBU9c__"